import React from 'react';
import _ from 'lodash';
import { Stack, Button, TextField } from '@mui/material';
import { changeSharedAccommodationInfoAction } from '../../../services/request';
import { useMutation } from 'react-fetching-library';
import toast from 'react-hot-toast';


export const SharedAccommodationForm = ({ id, sharedAccommodationInfo, setIsSent }) => {
  const { loading, mutate } = useMutation(changeSharedAccommodationInfoAction);
  const [value, setValue] = React.useState(sharedAccommodationInfo);

  const handleClick = async () => {
    const { error, loading, payload } = await mutate(id, { shared_accommodation_info: value });
    if (!error && !loading) {
      // toast.success('Wiadomość została wysłana, teraz oczekuj na potwierdzenie.');
      setIsSent(true);
    } else {
      toast.error('Nie udało się zapisać zmian');
    }
  };

  React.useEffect(() => {
    setValue(sharedAccommodationInfo);
  }, [sharedAccommodationInfo]);

  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      spacing={4}
      mt={8}
    >
      <TextField
        label={'Uwagi dotyczące wspólnego zakwaterowania'}
        placeholder="wpisz uwagi..."
        multiline
        rows={3}
        onChange={e => setValue(e.target.value)}
        value={value}
        sx={{ width: { xs: '250px', sm: '500px' } }}
      />
      <Button
        variant="contained"
        onClick={handleClick}
        sx={{ width: { xs: '250px', sm: '300px' } }}
        disabled={loading}
      >
        Wyślij prośbę o wspólne zakwaterowanie
      </Button>
    </Stack>
  );
};
